import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row q-col-gutter-md"
}
const _hoisted_2 = {
  key: 2,
  class: "text-center text-grey-6 q-pa-xl"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Trash is empty", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_TrashedPersonCard = _resolveComponent("TrashedPersonCard")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_infinite_scroll = _resolveComponent("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_linear_progress, {
          key: 0,
          color: "primary",
          indeterminate: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.persons.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
            return (_openBlock(), _createElementBlock("div", {
              key: person.id,
              class: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
            }, [
              _createVNode(_component_TrashedPersonCard, {
                person: person,
                onRestored: _ctx.onPersonRestored
              }, null, 8, ["person", "onRestored"])
            ]))
          }), 128))
        ]))
      : (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_q_icon, {
              name: "fa fa-trash",
              size: "64px",
              class: "q-mb-md"
            }),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_infinite_scroll, {
      active: _ctx.hasMore,
      loading: _ctx.loadingMore,
      class: "q-mt-md",
      onLoadMore: _ctx.loadMore
    }, null, 8, ["active", "loading", "onLoadMore"])
  ]))
}